module.exports = __webpack_public_path__ + "media/promo/courses/images/media-leaf-94519d9c6e2f67e118b2753a3a12b486.png";